import { Box } from '@mui/material'
import { NavLink } from 'react-router-dom';
import { PropsWithChildren } from 'react';


type NavItemProps = Readonly<PropsWithChildren<{
    handleLinkClick: (path: string) => void,
    route: string
}>>

export const NavItem = ({ handleLinkClick, route, children }: NavItemProps) => {
    return (
        <>
            <Box component={NavLink}
                end
                to={route}
                key={route}
                onClick={() => handleLinkClick(location.pathname)}
                sx={{ pb: 0, px: 0, mx: 2, color: 'white', display: 'block', textDecoration: "none", textTransform: 'capitalize', "&.active": { borderBottom: "2px solid white", } }}
            >
                {children}
            </Box>
        </>
    )
}


